export type UsageChargeType =
    | "VOICE_PER_MINUTE"
    | "CALL_TRANSFER"
    | "NUMBER_RENTAL"
    | "CALL_CENTRE_MINUTE"
    | "CALL_CENTRE_RENTAL"
    | "SMS";

export type UsageChargeUnit = "minute" | "transfer" | "month" | "segment" | "message";

export interface PublicRateLine {
    chargeType: UsageChargeType;
    carrier: string | null;
    carrierLabel: string | null;
    unit: UsageChargeUnit;
    amountMinor: number;
    currency: string;
    account: "platform" | "own" | null;
}

export interface PublicCreditBurn {
    chargeType: UsageChargeType;
    unit: UsageChargeUnit;
    credits: number;
}

export interface PublicRateCard {
    currency: "usd" | "inr";
    voice: PublicRateLine[];
    committedVoice: { perMinuteMinor: number; minMonthlyMinutes: number } | null;
    callCentre: PublicRateLine[];
    sms: PublicRateLine[];
    credits: PublicCreditBurn[] | null;
    billing: {
        collection: "card" | "invoice";
        voiceAutoChargeAtMinor: number | null;
        callCentreAutoChargeAtMinor: number | null;
        smsAutoChargeAtMinor: number | null;
        minimumChargeMinor: number;
    };
}

export const UNIT_SUFFIX: Record<UsageChargeUnit, string> = {
    minute: "/ min",
    transfer: "/ transfer",
    month: "/ month",
    segment: "/ segment",
    message: "/ SMS",
};

export const CHARGE_LABEL: Record<UsageChargeType, string> = {
    VOICE_PER_MINUTE: "AI agent minute",
    CALL_TRANSFER: "Warm transfer to a human",
    NUMBER_RENTAL: "Phone number",
    CALL_CENTRE_MINUTE: "Agent minute",
    CALL_CENTRE_RENTAL: "Call-centre number",
    SMS: "SMS segment",
};
